import { ReactNode } from "react";
import { create } from "zustand";

export interface ISideBladeStore {
  isOpen: boolean;
  body: ReactNode | null;
  openSideBlade: (content: ReactNode) => void;
  closeSideBlade: () => void;
}

const useSideBladeStore = create<ISideBladeStore>((set) => ({
  isOpen: false,
  body: null,
  openSideBlade: (content) => set({ isOpen: true, body: content }),
  closeSideBlade: () => set({ isOpen: false, body: null }),
}));

export default useSideBladeStore;
